<template>
  <div class="score-management-container">
    <!-- 頁面標題 -->
    <div class="page-header">
      <div class="header-content">
        <div class="title-section">
          <h1 class="page-title">
            <a-icon type="crown" class="title-icon" />
            學分管理(其它加分)
          </h1>
          <p class="page-description">組織內其它加分與交易記錄</p>
        </div>
        <div class="stats-cards" v-if="defaultval.type=='admin'">
          <div class="stat-card">
            <div class="stat-number">{{ myData.length || 0 }}</div>
            <div class="stat-label">本期給分</div>
          </div>
          <div class="stat-card">
            <div class="stat-number">{{ historyData.length || 0 }}</div>
            <div class="stat-label">歷史紀錄</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 主要內容區域 -->
    <div class="main-content" v-if="defaultval.type=='admin'">
      <a-tabs 
        v-model="activeTab" 
        class="modern-tabs"
        type="card"
        :animated="{ inkBar: true, tabPane: true }"
      >
        <!-- 給分作業頁籤 -->
        <a-tab-pane key="score" class="tab-pane">
          <span slot="tab" class="tab-title">
            <a-icon type="plus-circle" />
            給分作業
          </span>
          
          <div class="tab-content">
            <!-- 操作區域 -->
            <div class="action-bar">
              <div class="action-info">
                <h3 class="section-title">
                  <a-icon type="gift" />
                  學分給分操作
                </h3>
                <p class="section-desc">為組織成員進行學分的增加或扣除</p>
              </div>
              <a-button 
                @click="sendMsg()" 
                type="primary" 
                size="large"
                class="add-score-btn"
              >
                <a-icon type="plus" />
                新增給分
              </a-button>
            </div>

            <!-- 資料表格 -->
            <div class="table-container">
              <a-table 
                v-if="Array.isArray(myData) && myData.length > 0"
                :columns="enhancedColumns"
                :row-key="record => record.id"
                :data-source="myData"
                :pagination="enhancedPagination"
                :loading="loading"
                @change="handleTableChange"
                class="modern-table"
                :scroll="{ x: 1000 }"
              >    
                <template slot="amount" slot-scope="record">
                  <div class="amount-cell">
                    <a-tag 
                      :color="record.amount > 0 ? 'green' : record.amount < 0 ? 'red' : 'default'"
                      class="amount-tag"
                    >
                      {{ record.amount > 0 ? '+' : '' }}{{ record.amount }}
                    </a-tag>
                  </div>
                </template>
                
                <template slot="type" slot-scope="record">
                  <a-badge 
                    :status="record.type === 'earning' ? 'success' : 'error'"
                    :text="coverNameType(record.type)"
                  />
                </template>
                
                <template slot="action" slot-scope="record">
                  <a-tag :color="getActionColor(record.action)">
                    {{ coverNameAction(record.action) }}
                  </a-tag>
                </template>
                
                <template slot="created_at" slot-scope="record">
                  <div class="time-cell">
                    <a-icon type="clock-circle" />
                    {{ fdateformat(record.created_at) }}
                  </div>
                </template>
              </a-table>

              <!-- 空狀態 -->
              <div v-else class="empty-state">
                <a-empty                  
                  description="暫無給分記錄"
                >
                  <a-button type="primary" @click="sendMsg()">
                    <a-icon type="plus" />
                    立即給分
                  </a-button>
                </a-empty>
              </div>
            </div>
          </div>
        </a-tab-pane>

        <!-- 交易記錄頁籤 -->
        <a-tab-pane key="history" class="tab-pane">
          <span slot="tab" class="tab-title">
            <a-icon type="history" />
            交易記錄
          </span>
          
          <div class="tab-content">
            <!-- 資訊區域 -->
            <div class="info-bar">
              <h3 class="section-title">
                <a-icon type="file-text" />
                完整交易歷史
              </h3>
              <p class="section-desc">查看所有學分交易的詳細記錄</p>
            </div>

            <!-- 歷史記錄表格 -->
            <div class="table-container">
              <a-table 
                v-if="Array.isArray(historyData) && historyData.length > 0"
                :columns="enhancedColumns"
                :row-key="record => record.id"
                :data-source="historyData"
                :pagination="enhancedHPagination"
                :loading="loading2"
                @change="handleTableChange2"
                class="modern-table"
                :scroll="{ x: 1000 }"
              >    
                <template slot="amount" slot-scope="record">
                  <div class="amount-cell">
                    <a-tag 
                      :color="record.amount > 0 ? 'green' : record.amount < 0 ? 'red' : 'default'"
                      class="amount-tag"
                    >
                      {{ record.amount > 0 ? '+' : '' }}{{ record.amount }}
                    </a-tag>
                  </div>
                </template>
                
                <template slot="type" slot-scope="record">
                  <a-badge 
                    :status="record.type === 'earning' ? 'success' : 'error'"
                    :text="coverNameType(record.type)"
                  />
                </template>
                
                <template slot="action" slot-scope="record">
                  <a-tag :color="getActionColor(record.action)">
                    {{ coverNameAction(record.action) }}
                  </a-tag>
                </template>
                
                <template slot="created_at" slot-scope="record">
                  <div class="time-cell">
                    <a-icon type="clock-circle" />
                    {{ fdateformat(record.created_at) }}
                  </div>
                </template>
              </a-table>

              <!-- 空狀態 -->
              <div v-else class="empty-state">
                <a-empty 
                  :image="emptyImage" 
                  description="暫無交易記錄"
                >
                  <a-button type="default" @click="reload">
                    <a-icon type="reload" />
                    重新載入
                  </a-button>
                </a-empty>
              </div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>

    <!-- 無權限提示 -->
    <div v-else class="no-permission">
      <div class="no-permission-content">
        <a-icon type="lock" class="lock-icon" />
        <h2 style="color: #a6a5a5">存取受限</h2>
        <p style="color: #a6a5a5">您沒有該項目的管理權限，請聯繫系統管理員</p>
        <a-button type="primary" @click="$router.go(-1)">
          <a-icon type="arrow-left" />
          返回上頁
        </a-button>
      </div>
    </div>

    <!-- 給分彈窗 -->
    <a-modal
      v-model="showModal"
      :title="null"
      :footer="null"
      :centered="true"
      :width="900"
      @cancel="cancelObj"
      destroyOnClose
      class="score-modal"
    >
      <div class="modal-header">
        <div class="modal-title">
          <a-icon type="gift" class="modal-icon" />
          <span>非活動給分</span>
        </div>
        <div class="modal-subtitle">為組織成員進行學分的增加或扣除操作</div>
      </div>

      <a-spin :spinning="spinning" tip="資料處理中...">
        <div class="modal-content">
          <!-- 表單區域 -->
          <div class="form-section">
            <h4 class="form-title">
              <a-icon type="form" />
              給分資訊
            </h4>
            <a-form :model="form" layout="vertical" class="score-form">
              <a-row :gutter="16">
                <a-col :span="8">
                  <a-form-item label="交易點數">
                    <a-input-number 
                      v-model="form.amount" 
                      :min="-9999" 
                      :max="9999" 
                      style="width: 100%;" 
                      placeholder="正數增加，負數扣除"
                      size="large"
                    />
                    <div class="form-help">正數為增加學分，負數為扣除學分</div>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="交易類型">
                    <a-select 
                      v-model="form.type" 
                      placeholder="請選擇類型" 
                      @change="onTypeChange"
                      size="large"
                    >
                      <a-select-option value="" disabled>請選擇</a-select-option>
                      <a-select-option value="earning">
                        <a-icon type="arrow-up" style="color: #52c41a;" />
                        增加
                      </a-select-option>
                      <a-select-option value="spending">
                        <a-icon type="arrow-down" style="color: #ff4d4f;" />
                        扣除
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="交易動作">
                    <a-select 
                      v-model="form.action" 
                      placeholder="請選擇動作"
                      size="large"
                    >
                      <a-select-option value="" disabled>請選擇</a-select-option>
                      <a-select-option :value="1">
                        <a-icon type="shopping" />
                        購物紅利
                      </a-select-option>
                      <a-select-option :value="2">
                        <a-icon type="trophy" />
                        表現優異
                      </a-select-option>
                      <a-select-option :value="3">
                        <a-icon type="more" />
                        其它
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-form-item label="交易說明">
                <a-textarea 
                  v-model="form.detail" 
                  placeholder="請詳細說明此次給分的原因..." 
                  :rows="3"
                  size="large"
                />
              </a-form-item>
            </a-form>
          </div>

          <!-- 人員選擇區域 -->
          <div class="member-section">
            <h4 class="form-title">
              <a-icon type="team" />
              選擇人員
              <a-badge :count="selectedman.length" :offset="[10, 0]" />
            </h4>
            <div class="member-selector">
              <MsgObject @toMember="toMember" ref="msgObj" />
            </div>
          </div>

          <!-- 操作按鈕 -->
          <div class="modal-actions">
            <a-button size="large" @click="cancelObj()">
              <a-icon type="close" />
              取消
            </a-button>
            <a-button
              type="primary"
              size="large"
              @click="submitScore"
              :disabled="selectedman.length === 0 || !form.amount || !form.type || !form.action || !form.detail"
              class="submit-btn"
            >
              <a-icon type="check" />
              確認給分
            </a-button>
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import * as moment from "moment/moment";
import MsgObject from "./ScoreObj.vue"  
import { joinService } from '../../../_services'
import { mapState } from "vuex"; 

const postCorporalScore = obj => {
    return joinService.postPersonalScore(obj) 
}
const queryData = params => {
  return joinService.findPersonalScore(params) 
}; 
const queryData2 = params => {
  return joinService.findAllPersonalRecordScore(params) 
}; 

const columns = [
  {
    title: '執行人',
    dataIndex: 'tdisplayname',
    width: '15%',
    scopedSlots: { customRender: 'tdisplayname' },
  },
  {
    title: '接收人',
    dataIndex: 'udisplayname',
    width: '15%',
    scopedSlots: { customRender: 'udisplayname' },
  },
  {
    title: '學分',
    dataIndex: '',
    width: '12%',
    scopedSlots: { customRender: 'amount' },
    align: 'center',
  },
  {
    title: '交易類型',
    dataIndex: '',
    width: '12%',
    scopedSlots: { customRender: 'type' },
    align: 'center',
  },
  {
    title: '交易動作',
    dataIndex: '',
    width: '12%',
    scopedSlots: { customRender: 'action' },
    align: 'center',
  },
  {
    title: '交易說明',
    dataIndex: 'detail',
    width: '20%',
    scopedSlots: { customRender: 'detail' },
  },
  {
    title: '建置時間',
    dataIndex: 'created_at',
    width: '14%',
    scopedSlots: { customRender: 'created_at' },
    align: 'center',
  },
];

export default {
  name: 'Score_control', 
  components: {
    MsgObject
  },     
  data() {
    return {
      data: [],
      myData:[],
      historyData:[],
      pagination: {defaultPageSize:8}, 
      hpagination: {defaultPageSize:8, current:1},
      loading: false, 
      loading2: false, 
      columns, 
      actives:{page1:false,page2:true,page3:false},
      selectedman:[],
      activeTab: "score",
      spinning: false,
      showModal: false,
      form: {
          tid:0,
          oid:0,          
          amount: 0,
          type: '',
          action: '',
          detail: '',
          Vendorname:'',
          selectedman: [],
      },
      emptyImage: '/static/empty.svg', // 空狀態圖片
    };
  },
  computed: {
    ...mapState("account", ["status", "user"]),
    ...mapState("makeorg", ["defaultval"]),
    
    enhancedColumns() {
      return columns.map(col => ({
        ...col,
        className: 'table-cell'
      }));
    },
    
    enhancedPagination() {
      return {
        ...this.pagination,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `第 ${range[0]}-${range[1]} 條，共 ${total} 條記錄`,
        pageSizeOptions: ['8', '16', '24', '48'],
      };
    },
    
    enhancedHPagination() {
      return {
        ...this.hpagination,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `第 ${range[0]}-${range[1]} 條，共 ${total} 條記錄`,
        pageSizeOptions: ['8', '16', '24', '48'],
      };
    },
  },
  watch: {
    defaultval() {
      this.reload();
    }
  },  
  mounted() {
    this.reload();
  },
  methods: {
    fdateformat(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    },

    reload(){
      this.fetch({results:8,page:1,pageSize: this.pagination.pageSize || 8,oid:parseInt(this.defaultval.id) });
      this.fetch2({results:8,page:1,pageSize: this.hpagination.pageSize || 8 });
    },

    sendMsg(){
      this.clearForm();
      this.showModal = true;
    },

    clearForm(){
      this.form = {
            tid:0,
            oid:0,
            amount: 0,
            type: '',
            action: '',
            detail: '',
            Vendorname:'',
            selectedman: [],
        }
    },
    
    cancelObj(){
       this.showModal = false; 
    },

    iniScore(){ 
        this.showModal = false; 
        this.selectedman = [] 
        this.form.selectedman = [] 
    },
    
    toMember(obj){
      this.selectedman = obj.map(uid => ({ uid }));
      this.form.selectedman = this.selectedman;
    },  
    
    async submitScore() {
      this.$confirm({
        title: '確認給分操作',
        content: '給分確認後將無法修改，是否確定要執行此操作？',
        okText: '確認給分',
        cancelText: '取消',
        onOk: async () => {
          this.spinning = true;
          this.form.tid = parseInt(this.user.data.user.id);
          this.form.oid = parseInt(this.defaultval.id);
          try {
            const data = await postCorporalScore(this.form);
            if (data) {
              setTimeout(() => {
                this.clearForm();
                this.spinning = false;
                this.reload();
                this.iniScore();
                this.$message.success("給分操作成功完成！");
              }, 2000);
            } else {
              this.clearForm();
              this.spinning = false;
              this.iniScore();
              this.$message.error("給分操作失敗，請稍後再試");
            }
          } catch (error) {
            this.spinning = false;
            this.$message.error("系統錯誤，請聯繫管理員");
          }
        }
      });
    },

    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.fetch({
          pageSize: pagination.pageSize,
          page: pagination.current,
          sortField: sorter.field,
          sortOrder: sorter.order,
          oid: parseInt(this.defaultval.id),
          ...filters,
      });
    }, 
    
    fetch(params = {}) {
      this.loading = true;
      queryData({
          ...params,
      }).then(({ data }) => {
          const pagination = { ...this.pagination };
          pagination.total = data.info.totail;
          this.loading = false;
          this.myData = data.results;
          this.pagination = pagination; 
      });
    },

    handleTableChange2(pagination, filters, sorter) {
      const pager = { ...this.hpagination };
      pager.current = pagination.current;
      this.hpagination = pager;
      this.fetch2({
          pageSize: pagination.pageSize,
          page: pagination.current,
          sortField: sorter.field,
          sortOrder: sorter.order,
          ...filters,
      });
    }, 
    
    fetch2(params = {}) {
      this.loading2 = true;
      queryData2({
          ...params,
      }).then(({ data }) => {
          const pagination = { ...this.hpagination };
          pagination.total = data.info.totail;
          this.loading2 = false;
          this.historyData = data.results;
          this.hpagination = pagination; 
      });
    },    
    
    coverNameType(type) {
      if (type === 'earning') return '增加';
      if (type === 'spending') return '扣除';
      return '';
    },

    coverNameAction(action) {
      if (action === 1 || action === '1') return '購物紅利';
      if (action === 2 || action === '2') return '表現優異';
      if (action === 3 || action === '3') return '其它';  
      if (action === 4 || action === '4') return '移轉點數';
      if (action === 5 || action === '5') return '未綁定LINE帳號交易';
      return '';
    },
    
    getActionColor(action) {
      const colorMap = {
        1: 'orange',
        2: 'green', 
        3: 'blue',
        4: 'purple'
      };
      return colorMap[action] || 'default';
    },
    
    onTypeChange(value) {
      if (this.form.amount === 0) return;
      if (value === 'spending' && this.form.amount > 0) {
        this.form.amount = -Math.abs(this.form.amount);
      } else if (value === 'earning' && this.form.amount < 0) {
        this.form.amount = Math.abs(this.form.amount);
      }
    }    
  },
};
</script>

<style scoped>
/* 主容器 */
.score-management-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 0;
}

/* 頁面標題區域 */
.page-header {
  background: linear-gradient(135deg, #c0c0c0 0%, #bdbec0 100%);
  padding: 32px 0;
  color: white;
  position: relative;
  overflow: hidden;
}

.page-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1;
}

.title-section {
  flex: 1;
}

.page-title {
  font-size: 36px;
  font-weight: 700;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  color: white;
}

.title-icon {
  font-size: 40px;
  margin-right: 16px;
  color: #ced4da;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.page-description {
  font-size: 16px;
  opacity: 0.9;
  margin: 0;
  color: rgba(255,255,255,0.9);
}

/* 統計卡片 */
.stats-cards {
  display: flex;
  gap: 20px;
}

.stat-card {
  background: rgba(255,255,255,0.25);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  border: 1px solid rgba(255,255,255,0.3);
  min-width: 120px;
}

.stat-number {
  font-size: 32px;
  font-weight: 700;
  color: #f8f9fa;
  margin-bottom: 4px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.stat-label {
  font-size: 14px;
  color: rgba(255,255,255,0.9);
}

/* 主要內容區域 */
.main-content {
  max-width: 1200px;
  margin: -20px auto 0;
  padding: 0 24px 40px;
  position: relative;
  z-index: 2;
}

/* 現代化標籤頁 */
.modern-tabs {
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.05);
  overflow: hidden;
}

.modern-tabs /deep/ .ant-tabs-bar {
  background: linear-gradient(90deg, #f8f9fa 0%, #e9ecef 100%);
  border: none;
  margin: 0;
}

.modern-tabs /deep/ .ant-tabs-tab {
  border: none;
  background: transparent;
  margin-right: 0;
  padding: 16px 32px;
  font-weight: 600;
  transition: all 0.3s ease;
  color: #495057;
}

.modern-tabs /deep/ .ant-tabs-tab:hover {
  background: rgba(108, 117, 125, 0.1);
  color: #343a40;
}

.modern-tabs /deep/ .ant-tabs-tab-active {
  background: #6c757d;
  color: white !important;
  border-radius: 8px 8px 0 0;
}

.modern-tabs /deep/ .ant-tabs-ink-bar {
  display: none;
}

.tab-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tab-content {
  padding: 32px;
  min-height: 600px;
}

/* 操作區域 */
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  padding: 24px;
  background: linear-gradient(135deg, #adb5bd 0%, #868e96 100%);
  border-radius: 12px;
  color: white;
}

.action-info h3.section-title {
  color: white;
  margin: 0 0 8px 0;
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-info .section-desc {
  color: rgba(255,255,255,0.9);
  margin: 0;
}

.add-score-btn {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  font-weight: 600;
  border-radius: 8px;
  height: 48px;
  padding: 0 24px;
}

.add-score-btn:hover {
  background: #e9ecef;
  color: #343a40;
  border-color: #ced4da;
}

/* 資訊區域 */
.info-bar {
  margin-bottom: 32px;
  padding: 24px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  border: 1px solid #dee2e6;
}

.info-bar h3.section-title {
  color: #495057;
  margin: 0 0 8px 0;
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-bar .section-desc {
  color: #6c757d;
  margin: 0;
}

/* 表格容器 */
.table-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.05);
  overflow: hidden;
  border: 1px solid #dee2e6;
}

.modern-table {
  border: none;
}

.modern-table /deep/ .ant-table-thead > tr > th {
  background: linear-gradient(90deg, #f8f9fa 0%, #e9ecef 100%);
  border: none;
  color: #495057;
  font-weight: 600;
  padding: 16px;
}

.modern-table /deep/ .ant-table-tbody > tr > td {
  border: none;
  padding: 16px;
  border-bottom: 1px solid #dee2e6;
  color: #495057;
}

.modern-table /deep/ .ant-table-tbody > tr:hover > td {
  background: #f8f9fa;
}

.modern-table /deep/ .table-cell {
  vertical-align: middle;
}

/* 表格內容樣式 */
.amount-cell {
  display: flex;
  justify-content: center;
}

.amount-tag {
  font-weight: 600;
  font-size: 14px;
  border-radius: 6px;
  padding: 4px 12px;
}

.time-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #6c757d;
  font-size: 13px;
}

/* 空狀態 */
.empty-state {
  padding: 80px 20px;
  text-align: center;
  background: white;
}

/* 無權限頁面 */
.no-permission {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.no-permission-content {
  text-align: center;
  color: white;
  max-width: 400px;
}

.lock-icon {
  font-size: 80px;
  color: #ced4da;
  margin-bottom: 24px;
  text-shadow: 0 4px 8px rgba(0,0,0,0.3);
}

.no-permission-content h2 {
  color: white;
  font-size: 28px;
  margin-bottom: 16px;
}

.no-permission-content p {
  color: rgba(255,255,255,0.9);
  font-size: 16px;
  margin-bottom: 32px;
  line-height: 1.6;
}

/* 彈窗樣式 */
.score-modal /deep/ .ant-modal-content {
  border-radius: 16px;
  overflow: hidden;
}

.score-modal /deep/ .ant-modal-body {
  padding: 0;
}

.modal-header {
  background: linear-gradient(135deg, #adb5bd 0%, #6c757d 100%);
  padding: 32px;
  color: white;
  text-align: center;
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 8px;
}

.modal-icon {
  font-size: 28px;
  color: #f8f9fa;
}

.modal-subtitle {
  color: rgba(255,255,255,0.9);
  font-size: 16px;
}

.modal-content {
  padding: 32px;
}

.form-section, .member-section {
  margin-bottom: 32px;
}

.form-title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #495057;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 8px;
}

.score-form {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #dee2e6;
}

.form-help {
  font-size: 12px;
  color: #6c757d;
  margin-top: 4px;
}

.member-selector {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #dee2e6;
  min-height: 200px;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding-top: 24px;
  border-top: 1px solid #dee2e6;
}

.submit-btn {
  background: linear-gradient(135deg, #adb5bd 0%, #6c757d 100%);
  border: none;
  font-weight: 600;
  color: white;
}

.submit-btn:hover {
  background: linear-gradient(135deg, #868e96 0%, #495057 100%);
  border: none;
  color: white;
}

/* 響應式設計 */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
  
  .stats-cards {
    justify-content: center;
  }
  
  .action-bar {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
  
  .main-content {
    padding: 0 16px 40px;
  }
  
  .tab-content {
    padding: 16px;
  }
}
</style>